import { ButtonGhost } from '@npco/zeller-design-system'

import * as styled from './DarkBlueButton.styled'

export const DarkBlueButton = (
  props: React.ComponentProps<typeof ButtonGhost>
) => {
  return <styled.DarkBlueButton {...props} />
}
